<template>
  <v-row>
    <v-col cols="12">
        <summary-card> </summary-card> 
    </v-col>
  </v-row>
</template>
<script>
import SummaryCard from "@/components/report/SummaryCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Summary Sales",
  },

  components: {
    SummaryCard
  },

  data() {
    return {
    };
  },
};
</script>